<script setup lang="ts">
/**
 * UI-kit component
 * Category: Links
 * Name: LinkTextPrimary
 */
import type { LinkTextPrimaryProps } from '../types/interfaces'

import { IconContainer } from '@shared/ui/other'

import { useLinkTextPrimary } from '../composables/use-link-text-primary.hook'

import { NuxtLink } from '#components'

defineOptions({
  name: 'LinkTextPrimary',
})

const props = withDefaults(defineProps<LinkTextPrimaryProps>(), {
  color: 'blue',
  target: '_self',
  disabled: false,
})

const {
  refIsBlankTarget,
} = useLinkTextPrimary({ props })
</script>

<template>
  <component
    :is="refIsBlankTarget ? 'a' : NuxtLink"
    :href="refIsBlankTarget ? href : undefined"
    :to="refIsBlankTarget ? null : href"
    :class="['link-text-primary', color, { disabled }]"
    :target="target"
  >
    <IconContainer v-if="$slots.iconLeft">
      <slot name="iconLeft" />
    </IconContainer>
    <slot />
    <IconContainer v-if="$slots.iconRight">
      <slot name="iconRight" />
    </IconContainer>
  </component>
</template>

<style lang="scss" scoped src="../styles/_link-text-primary.scss" />
